import React from "react";

import svg from "../../assets/images/icons/upload.svg";

export const UploadIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Upload"}
    />
);
